<template>
  <transition name="fade">
    <div v-if="precent" class="RoundProgress">
      <div class="circle">
        <div class="center">
          <div class="progress" :style="{
            width: precent+'%',
            height: precent+'%',
            background: `rgba(${precent/3}, ${precent*2}, ${precent/1.5}, 0.8)`
          }"> </div>
        </div>
        <p v-if="precent < 100">{{precent}} %</p>
        <p v-else style="font-size: 32rem">✔</p>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'RoundProgress',
  props: {
    visible: Boolean,
    progress: Number,
  },
  computed: {
    precent () {
      return this.progress < 100 ? this.progress : 100
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.RoundProgress {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  z-index: 9999;

  .circle {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;

    width: 80px;
    height: 80px;
    border-radius: 40px;
    border: 1px solid #999;

    .center {
      position: absolute;
      overflow: hidden;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 40px;

      .progress {
        background: #aaa;
        border-radius: 40px;
        transition: .05s all;
      }
    }

    p {
      z-index: 1;
      color: #fff;
      font-weight: 500;
    }
  }
}
</style>
